<script>
import Drawer from "@/components/drawer";
import VueDropify from "vue-dropify";
import Swal from "sweetalert2";
import VLazyImage from "v-lazy-image/v2";
import carousel from "vue-owl-carousel";
import MultiSelect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";

// Custom Components
import InfoAndServices from "@/components/hotel/ourHotel.vue";
import RoomDetail from "@/components/hotel/ourRoom.vue";
import Floor from "@/components/inventory/floor.vue";
import LocalEvent from "@/components/hotel/localEvent.vue";
import NearByPlace from "@/components/hotel/nearByPlace.vue";
import TVChannel from "@/components/hotel/tvChannel.vue";
import LightBox from "@/components/hotel/lightBox.vue";

import UserService from "@/helpers/APIService/user.service";
import hotelService from "@/helpers/APIService/hotel.service";
import GXPService from "@/helpers/APIService/gxp.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";

export default {
  emits: ["openHomePage"],
  props: {
    currentProps: Object,
  },
  components: {
    Drawer,
    VueDropify,
    VLazyImage,
    carousel,
    MultiSelect,
    InfoAndServices,
    RoomDetail,
    Floor,
    LocalEvent,
    NearByPlace,
    TVChannel,
    LightBox,
  },
  computed: {
    ...authComputed,
    infoAndServicesProps() {
      return {
        selectedInfoAndServices: this.dataToBeSendInProps,
        isEdit: true,
      };
    },
    RoomDetailProps() {
      return {
        selectedRoomDetail: this.dataToBeSendInProps,
        isEdit: this.isEdit,
      };
    },
    floorProps() {
      return {
        selectedFloor: this.dataToBeSendInProps,
        isEdit: true,
      };
    },
    localEventProps() {
      return {
        selectedLocalEvent: this.dataToBeSendInProps,
        isEdit: this.isEdit,
      };
    },
    nearByPlaceProps() {
      return {
        selectedNearByPlace: this.dataToBeSendInProps,
        isEdit: true,
      };
    },
    tvChannelProps() {
      return {
        selectedTVChannel: this.dataToBeSendInProps,
        isEdit: true,
      };
    },
    lightBoxData() {
      return {
        lightBoxPageOptions: this.lightBoxPageOptions,
        openPageOptions: this.openPageOptions,
        selectedPage:
          this.selectedCategory.feature_code !== undefined
            ? this.selectedCategory.feature_code
            : this.selectedCategory.id,
      };
    },
  },
  mounted() {
    this.manageDetailPage();
  },
  data() {
    return {
      plugins: [
        "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table contextmenu directionality emoticons template paste textcolor",
      ],
      toolbar:
        "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons",
      options: {
        height: 300,
        style_formats: [
          { title: "Bold text", inline: "b" },
          { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
          { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
          { title: "Example 1", inline: "span", classes: "example1" },
          { title: "Example 2", inline: "span", classes: "example2" },
          { title: "Table styles" },
          { title: "Table row 1", selector: "tr", classes: "tablerow1" },
        ],
      },
      categoryPage: [],
      isPageActive: false,
      selectedCategory: "Category",
      isMainPage: false,
      categoryData: {},
      isEdit: false,
      isPageHasSubCategory: false,
      mainCategory: null,
      isCategoryDetail: false,
      dataToBeSendInProps: {},
      isHaveDetails: true,
      dataLoading: true,
      lastSelectedCategory: null,
      hotelDrawerOpen: false,
      imgUrl: null,
      submittedCategoryData: false,
      isCategoryDataBtnLoading: false,
      // Dynamic Page Related Variables
      page_template_type: null,
      categoryUpdateData: {
        id: null,
        name: null,
        image: null,
        images: [],
        description: null,
        is_active: true,
      },
      dynamicPages: [],
      addNewPageImages: [],
      isAddNewPage: false,
      PageTitle: "Add New Page",
      PageData: {
        name: null,
        image: null,
        images: [],
        description: null,
        is_active: true,
        redirect_url: "https://www.google.com/",
        template_page_type: null,
        selected_template: null,
      },
      pageTypeOptions: [],
      isTemplateSelect: false,
      isAddPageBtnLoading: false,
      isRemovePageBtnLoading: false,
      isAddNewPageDataBtnLoading: false,
      submittedAddNewPage: false,
      // Light Box Related Variables
      isShowLightBox: false,
      lightBoxPageOptions: [],
      openPageOptions: [],
    };
  },
  validations: {
    PageData: {
      name: {
        required,
      },
    },
  },
  methods: {
    // Method is use for handle detail page add
    manageDetailPage() {
      if (this.currentProps.categoryToShow !== undefined) {
        this.getDataFromApi(this.currentProps.categoryToShow);
      }
      this.openPageOptions = this.currentProps.lightBoxPageOptions;
    },
    // Method is use for call API based on selected category
    async getDataFromApi(data, status) {
      this.isPageActive = true;
      this.dataLoading = true;
      this.isHaveDetails = false;
      if (
        data.is_active_super_panel !== undefined ||
        data.feature_code !== undefined
      ) {
        this.selectedCategory = data;
        this.appFeatureApiCall(data, status);
      } else {
        this.extraPageApiCall(data);
        this.selectedCategory = data;
      }
    },
    // Method is used to call details apis for hotel features
    async appFeatureApiCall(data, subProcess) {
      if (data.feature_code == 103 || data.feature_code == 104) {
        const filter =
          data.feature_code == 103
            ? "?info_place_type=room"
            : "?info_place_type=hotel";
        await hotelService
          .getInfoAndServices(filter)
          .then((response) => {
            if (response.length !== 0) {
              response.map((item) => {
                const modifyData = this.modifyData(
                  {
                    ...item,
                    feature_code: data.feature_code,
                  },
                  data.feature_code
                );
                this.categoryPage.push(modifyData);
              });
            }
            this.dataLoading = false;
          })
          .catch((error) => {
            this.dataLoading = false;
            errorHandler(error);
          });
      }
      if (data.feature_code == 109) {
        await UserService.getLocalEventList("?size=" + 100)
          .then((response) => {
            if (response.length !== 0) {
              response.map((item) => {
                item = {
                  ...item,
                  feature_code: 109,
                  thumbnailImage: item.image,
                  images: [],
                  description: item.description,
                };
                this.categoryPage.push(item);
              });
            }
            this.dataLoading = false;
          })
          .catch((error) => {
            this.dataLoading = false;
            errorHandler(error);
          });
      }
      if (data.feature_code == 105) {
        await UserService.getFloorList()
          .then((response) => {
            if (response.length !== 0) {
              response.map((item) => {
                const data = this.modifyData(
                  {
                    ...item,
                    feature_code: 105,
                  },
                  105
                );
                this.categoryPage.push(data);
              });
            }
            this.dataLoading = false;
          })
          .catch((error) => {
            this.dataLoading = false;
            errorHandler(error);
          });
      }
      if (data.feature_code == 108) {
        this.isMainPage = true;
        this.categoryPage = [];
        await hotelService
          .getNearByPlaceCategory()
          .then((response) => {
            if (response.length !== 0) {
              response.map((item) => {
                const data = this.modifyData(
                  { ...item, feature_code: 108 },
                  "image"
                );
                this.categoryPage.push(data);
              });
            }
            this.dataLoading = false;
          })
          .catch((error) => {
            this.dataLoading = false;
            errorHandler(error);
          });
      }
      if (data.feature_code == 108 && subProcess == "sub-page") {
        this.lastSelectedCategory = data.name;
        this.isPageHasSubCategory = true;
        this.mainCategory = "nearby-place";
        this.categoryPage = [];
        const query = "?place_category=" + data.id;
        await hotelService
          .getNearByPlaceList(query)
          .then((response) => {
            if (response.length !== 0) {
              response.map((item) => {
                const data = this.modifyData(
                  { ...item, feature_code: 108 },
                  108
                );
                this.categoryPage.push(data);
              });
            }
            this.dataLoading = false;
          })
          .catch((error) => {
            this.dataLoading = false;
            errorHandler(error);
          });
      }
      if (data.feature_code == 110) {
        this.isMainPage = true;
        this.categoryPage = [];
        await UserService.getTvChannelCategory()
          .then((response) => {
            if (response.length !== 0) {
              response.map((item) => {
                const data = this.modifyData(
                  { ...item, feature_code: 110 },
                  "image"
                );
                this.categoryPage.push(data);
              });
            }
            this.dataLoading = false;
          })
          .catch((error) => {
            this.dataLoading = false;
            errorHandler(error);
          });
      }
      if (data.feature_code == 110 && subProcess == "sub-page") {
        this.lastSelectedCategory = data.name;
        this.isPageHasSubCategory = true;
        this.mainCategory = "tv-channel";
        this.categoryPage = [];
        const query = "?tv_channel_category=" + data.id;
        await UserService.getTvChannelList(query)
          .then((response) => {
            if (response.length !== 0) {
              response.map((item) => {
                const data = this.modifyData(
                  { ...item, feature_code: 110 },
                  "image"
                );
                this.categoryPage.push(data);
              });
            }
            this.dataLoading = false;
          })
          .catch((error) => {
            this.dataLoading = false;
            errorHandler(error);
          });
      }
      const onStaticCode = [103, 104, 105, 108, 109, 110];
      if (!onStaticCode.includes(data.feature_code)) {
        this.isCategoryDetail = true;
        this.categoryData.name = data.name;
        this.isHaveDetails = true;
        this.dataLoading = false;
      } else {
        this.isHaveDetails = false;
      }
      this.categoryPage.map((item) => {
        this.lightBoxPageOptions.push({
          text: item.name,
          value: item.feature_code,
          type: "number",
        });
        this.openPageOptions.push({
          text: item.name,
          value: item.feature_code,
          type: "number",
        });
      });
    },
    // Method is used to call extra pages api call
    async extraPageApiCall(data) {
      if (data.page_level !== this.selectedCategory.page_level) {
        this.dynamicPages = [];
        this.categoryPage = [];
      }
      await GXPService.getPageDetails(data.id)
        .then((response) => {
          if (response.page_template_type !== "content_page") {
            if (response.sub_pages.length !== 0) {
              this.isHaveDetails = false;
              response.sub_pages.map((item) => {
                this.dynamicPages.push(item);
                const modifyData = this.modifyData(item, "dynamic");
                this.categoryPage.push(modifyData);
              });
            } else {
              this.categoryPage = [];
              this.dynamicPages = [];
            }
            this.dataLoading = false;
          } else {
            this.isCategoryDetail = true;
            this.categoryData = this.modifyData(response, "dynamic");
            this.selectedCategory = response;
            this.hotelButton(this.categoryData);
            this.dataLoading = false;
          }
        })
        .catch((error) => {
          this.dataLoading = false;
          errorHandler(error);
        });
      if (this.categoryPage.length !== 0) {
        this.categoryPage.map((item) => {
          this.lightBoxPageOptions.push({
            text: item.name,
            value: item.id,
            type: "uuid",
          });
          this.openPageOptions.push({
            text: item.name,
            value: item.id,
            type: "uuid",
          });
        });
      }
    },
    // Method is use for handle page click
    openMainCategoryPageDetail(data) {
      this.isEdit = !this.isEdit ? true : this.isEdit;
      if (data.page_template_type !== undefined) {
        if (data.page_template_type !== "redirect_url") {
          this.getDataFromApi(data);
        } else {
          window.open(data.redirect_url, "_blank");
        }
      } else {
        if (this.isMainPage && !this.isPageHasSubCategory) {
          this.getDataFromApi(data, "sub-page");
        } else {
          this.isCategoryDetail = true;
          this.categoryData = data;
          this.manageSendData(data);
        }
      }
    },
    // Method is use to handle gallery image change in new page add
    changeGalleryImage(event, data) {
      if (event[0] !== undefined) {
        if (data !== "add_new_page") {
          const imageData = new FormData();
          imageData.append("hd_page", data.id);
          imageData.append("image", event[0]);
          GXPService.updatePage(data.id, imageData).then((image) => {
            this.dynamicPages = this.dynamicPages.map((item) => {
              if (item.id == data.id) {
                item.image = image.image;
              }
              return item;
            });
            this.categoryData = this.modifyData({
              ...this.categoryData,
              image: image.image,
            });
          });
          setTimeout(() => {
            document.querySelector(".has-icon").click();
          }, 500);
        } else {
          this.PageData.image = event[0];
        }
      }
    },
    // Method is use to set image as thumbnail image
    changeThumbnailImageStatus(data) {
      GXPService.updatePageImage(data.hd_page, data.id, {
        is_thumbnail: data.is_thumbnail,
      })
        .then((response) => {
          this.categoryData.images = this.categoryData.images.map((image) => {
            if (image.id !== response.id) {
              image = { ...image, is_thumbnail: false };
            } else {
              image = { ...image, is_thumbnail: true };
            }
            return image;
          });
          Middleware.notification(
            "Successfully set as thumbnail image !!",
            "success"
          );
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use to delete image from page
    deleteCategoryPageImage(data) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete image!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          await GXPService.deletePageImage(data.hd_page, data.id)
            .then((response) => {
              Middleware.notification(
                "image deleted successfully !!",
                "danger"
              );

              this.categoryData.images = this.categoryData.images.filter(
                (img) => img.id !== data.id
              );
            })
            .catch((error) => errorHandler(error));
        }
      });
    },
    // Method is use to go back to category page
    goBackToCategory(data) {
      if (
        this.isHaveDetails ||
        this.selectedCategory.page_template_type == "content_page"
      ) {
        this.openHomePage();
      } else {
        if (data !== null) {
          this.categoryData = {};
        }
        this.isCategoryDetail = false;
      }
    },
    // Method is use for go back to home
    openHomePage() {
      if (this.isPageHasSubCategory) {
        this.isPageHasSubCategory = false;
        this.getDataFromApi(this.selectedCategory);
      } else {
        this.$emit("openHomePage", true);
        this.resetVariables();
        // if (this.selectedCategory.page_level == undefined) {
        //   this.$emit("openHomePage", true);
        // } else {
        //   if (this.selectedCategory.page_level == 1) {
        // } else {
        //   this.getDataFromApi(this.selectedCategory);
        // }
        // }
      }
    },
    // Method is use for handle hotel detail update
    hotelButton(data = null) {
      if (data !== null) {
        const hd_page_image = [];
        setTimeout(() => {
          this.categoryUpdateData = { ...data, hd_page_image };
        }, 200);
      }
      this.hotelDrawerOpen = !this.hotelDrawerOpen;
    },
    // Method is use for handle category status change
    changePageStatus(data) {
      if (this.isPageActive) {
        if (data.feature_code == 104) {
          hotelService
            .updateInfoAndServices(data.id, {
              is_active: !data.is_active,
            })
            .then((response) => {})
            .catch((error) => {
              errorHandler(error);
            });
        }
        if (data.feature_code == 103) {
          hotelService
            .updateInfoAndServices(data.id, {
              is_active: !data.is_active,
            })
            .then((response) => {})
            .catch((error) => {
              errorHandler(error);
            });
        }
        if (data.feature_code == 109) {
          UserService.updateLocalEvent(data.id, {
            is_active: !data.is_active,
          })
            .then((response) => {})
            .catch((error) => {
              errorHandler(error);
            });
        }
        if (data.feature_code == 108) {
          hotelService
            .updateNearByPlaceCategory(data.id, {
              is_active: !data.is_active,
            })
            .then((response) => {})
            .catch((error) => {
              errorHandler(error);
            });
        }
        if (data.feature_code == 110) {
          UserService.updateTvChannelCategory(data.id, {
            is_active: !data.is_active,
          })
            .then((response) => {})
            .catch((error) => {
              errorHandler(error);
            });
        }
        if (data.feature_code == 105) {
          UserService.editFloor(
            {
              is_active: !data.is_active,
            },
            data.id
          )
            .then((response) => {})
            .catch((error) => {
              errorHandler(error);
            });
        }
        if (data.page_template_type !== undefined) {
          GXPService.updatePage(data.id, {
            is_active: !data.is_active,
          })
            .then((response) => {})
            .catch((error) => {
              errorHandler(error);
            });
        }
        if (this.isMainPage && this.isPageHasSubCategory) {
          if (this.lastSelectedCategory == "nearby-place") {
            hotelService
              .updateNearByPlace(data.id, {
                is_active: !data.is_active,
              })
              .then((response) => {})
              .catch((error) => {
                errorHandler(error);
              });
          }
          if (this.lastSelectedCategory == "tv-channel") {
            UserService.updateTVChannel(data.id, {
              is_active: !data.is_active,
            })
              .then((response) => {})
              .catch((error) => {
                errorHandler(error);
              });
          }
        }
      }
      Middleware.notification("Status successfully Changed !!", "success");
    },
    // Method is use for manage send data in props
    manageSendData(data) {
      if (data.feature_code == 103 || data.feature_code == 104) {
        this.dataToBeSendInProps = {
          id: this.categoryData.id,
          description: this.categoryData.description,
          name: this.categoryData.name,
          hotel_info_place_image: this.categoryData.hotel_info_place_image,
        };
      }
      if (data.feature_code == 105) {
        this.dataToBeSendInProps = {
          id: this.categoryData.id,
          name: this.categoryData.name,
          short_name: this.categoryData.short_name,
          building: this.categoryData.building,
          floor_image: this.categoryData.floor_image,
        };
      }
      if (data.feature_code == 109) {
        this.dataToBeSendInProps = this.categoryData;
      }
      if (this.isMainPage) {
        this.dataToBeSendInProps = this.categoryData;
      }
      this.categoryPage = this.categoryPage.map((item) => {
        if (item.id == data.id) {
          console.log(item, "item");
        }
        return item;
      });
    },
    // Method is use for handle page detail form
    openCategoryPageDetails(data = null) {
      if (this.lastSelectedCategory == "dynamic") {
        this.hotelButton(this.categoryData);
      }
      if (data !== null) {
        if (data == "addNewPage") {
          this.isEdit = false;
          this.isPageActive = false;
          return;
        }
        this.isEdit = true;
        this.manageSendData(data);
        if (this.isPageActive) {
          this.isPageActive = false;
        }
      } else {
        this.extraPageApiCall(this.selectedCategory);
      }
    },
    // Method is use for handle category thumbnail image change
    changeCategoryThumbnailImage(event) {
      if (event[0] !== undefined) {
        this.categoryData.thumbnailImage = window.URL.createObjectURL(event[0]);
      }
    },
    // Method is use for category image change
    changeCategoryImage(event, status) {
      if (event[0] !== undefined) {
        const image = window.URL.createObjectURL(event[0]);
        if (status == "in_detail") {
          const imageData = new FormData();
          imageData.append("hd_page", this.selectedCategory.id);
          imageData.append("image", event[0]);
          if (this.categoryData.images.length == 1) {
            imageData.append("is_thumbnail", true);
          } else {
            imageData.append("is_thumbnail", false);
          }
          GXPService.addPageImage(this.selectedCategory.id, imageData).then(
            (response) => {
              this.categoryData.images.push(response);
            }
          );
          setTimeout(() => {
            document.querySelector(".has-icon").click();
          }, 500);
        } else {
          this.categoryUpdateData.image = event[0];
          this.imgUrl = event[0];
        }
      }
    },
    // Method is used to handle image change event
    changeMenuPageDataImage(event) {
      if (event[0] !== undefined) {
        this.imgUrl = event[0];
        this.PageData.image = window.URL.createObjectURL(event[0]);
      }
    },
    // Method is use for handle category add
    async handleCategorySubmit() {
      this.submittedCategoryData = true;
      this.isCategoryDataBtnLoading = true;
      if (this.selectedCategory.feature_code == 108) {
        try {
          const categoryUpdateData = new FormData();
          categoryUpdateData.append("name", this.categoryUpdateData.name);
          if (this.imgUrl !== null) {
            categoryUpdateData.append("image", this.imgUrl);
          }
          const response = await hotelService.updateNearByPlaceCategory(
            this.categoryUpdateData.id,
            categoryUpdateData
          );
          const data = this.modifyData(response, "image");
          this.categoryPage = this.categoryPage.map((item) => {
            if (item.id == data.id) {
              item = data;
            }
            return item;
          });
          Middleware.notification("Successfully updated !!", "success");

          this.isCategoryDataBtnLoading = false;
          this.submittedCategoryData = false;
        } catch (error) {
          this.isCategoryDataBtnLoading = false;
          errorHandler(error);
        }
      }
      if (this.selectedCategory.feature_code == 110) {
        try {
          const categoryUpdateData = new FormData();
          categoryUpdateData.append("name", this.categoryUpdateData.name);
          if (this.imgUrl !== null) {
            categoryUpdateData.append("image", this.imgUrl);
          }
          const response = await UserService.updateTvChannelCategory(
            this.categoryUpdateData.id,
            categoryUpdateData
          );
          const data = this.modifyData(response, "image");
          this.categoryPage = this.categoryPage.map((item) => {
            if (item.id == data.id) {
              item = data;
            }
            return item;
          });
          Middleware.notification("Successfully updated !!", "success");

          this.isCategoryDataBtnLoading = false;
          this.submittedCategoryData = false;
        } catch (error) {
          this.isCategoryDataBtnLoading = false;
          errorHandler(error);
        }
      }
      if (this.selectedCategory.page_template_type == "content_page") {
        try {
          const categoryUpdateData = new FormData();
          categoryUpdateData.append("name", this.categoryUpdateData.name);
          categoryUpdateData.append(
            "description",
            this.categoryUpdateData.description
          );
          let response = await GXPService.updatePage(
            this.categoryUpdateData.id,
            categoryUpdateData
          );
          this.updatePageDataHelper(response, "dynamic", "map");
          this.isCategoryDataBtnLoading = false;
          this.submittedCategoryData = false;
        } catch (error) {
          this.isCategoryDataBtnLoading = false;
          errorHandler(error);
        }
        this.categoryData = this.categoryUpdateData;
      }
      if (this.selectedCategory.feature_code !== undefined) {
        this.hotelButton();
      }
    },
    // Method is used to delete content page
    deleteCategoryPage(data) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          if (data.page_template_type !== undefined) {
            if (data.page_template_type == "content_page") {
              GXPService.deletePage(data.id);
              this.$emit("openHomePage", true);
              this.resetVariables();
            } else {
              Middleware.notification(
                "You can't delete this page !!",
                "success"
              );
            }
          }
        }
      });
    },
    // Method is used to handle template type change
    handleTemplateTypeSelection() {
      this.pageTypeOptions = [];
      if (this.PageData.template_page_type !== null) {
        if (this.PageData.template_page_type.value == "add_new_page") {
          this.addNewPageDrawerHandle();
        }
        if (this.PageData.template_page_type.value == "content_page") {
          GXPService.getPages("?page_template_type=content_page")
            .then((response) => {
              if (response.length !== 0) {
                response.map((page) => {
                  this.pageTypeOptions.push({
                    text: page.name,
                    value: page,
                  });
                });
              } else {
                Middleware.notification(
                  "No page available, please add new page !!",
                  "info"
                );
              }
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
        if (this.PageData.template_page_type.value == "list_page") {
          this.pageTypeOptions = [
            { text: "List Page First", value: "list_page_first" },
            { text: "List Page Second", value: "list_page_second" },
          ];
        }
      }
    },
    // Method is used to handle template change
    selectTemplate() {
      if (this.PageData.selected_template !== null) {
        this.isTemplateSelect = true;
        this.PageData.name = this.PageData.selected_template.value.name;
      }
    },
    // Method is use for handle add new page
    addNewPageDrawerHandle() {
      if (this.isAddNewPage) {
        this.PageData = {
          name: null,
          image: null,
          images: [],
          description: null,
          is_active: true,
          redirect_url: null,
          template_page_type: null,
          selected_template: null,
        };
        this.addNewPageImages = [];
      }
      this.isAddNewPage = !this.isAddNewPage;
    },
    // Method is usd to handle image change in add new page
    changeAddNewPageImage(event) {
      if (event[0] !== undefined) {
        this.addNewPageImages.push(window.URL.createObjectURL(event[0]));
        this.PageData.images.push(event[0]);
        this.imgUrl = null;
        setTimeout(() => {
          document.querySelector(".has-icon").click();
        }, 500);
      }
    },
    // Method is used to handle remove add new image
    deleteAddNewPageImage(index) {
      this.addNewPageImages = this.addNewPageImages.filter((item, ImgIndex) => {
        if (ImgIndex !== index) {
          return item;
        }
      });
      this.PageData.images = this.PageData.images.filter((item, ImgIndex) => {
        if (ImgIndex !== index) {
          return item;
        }
      });
    },
    handleNewPageSubmit() {
      this.submittedAddNewPage = true;
      this.isAddNewPageDataBtnLoading = true;
      this.$v.$touch();
      if (this.$v.PageData.$invalid) {
        this.isAddNewPageDataBtnLoading = false;
        return;
      } else {
        if (this.isAddNewPage) {
          if (
            this.PageData.template_page_type !== null &&
            this.PageData.template_page_type.value == "add_new_page"
          ) {
            const newPageData = new FormData();
            Object.keys(this.PageData).map((key) => {
              if (this.PageData[key] !== null) {
                if (
                  key !== "selected_template" &&
                  key !== "template_page_type"
                ) {
                  newPageData.append(key, this.PageData[key]);
                }
              }
            });
            newPageData.append("hotel", this.hotel.id);
            newPageData.append("page_template_type", "content_page");
            newPageData.append(
              "page_level",
              this.selectedCategory.page_level + 1
            );
            newPageData.delete("images");
            newPageData.delete("redirect_url");
            GXPService.addPage(newPageData)
              .then((response) => {
                this.dynamicPages.push(response);
                const data = this.modifyData(response);
                this.categoryPage.push(data);
                GXPService.addSubPages(
                  this.selectedCategory.id,
                  response.id,
                  "add"
                );
                this.submittedAddNewPage = false;
                this.isAddNewPageDataBtnLoading = false;
                this.addNewPageDrawerHandle();
                if (this.PageData.images.length !== 0) {
                  this.PageData.images.map(async (image, index) => {
                    const imageData = new FormData();
                    imageData.append("hd_page", response.id);
                    imageData.append("image", image);
                    if (index == 1) {
                      imageData.append("is_thumbnail", true);
                    } else {
                      imageData.append("is_thumbnail", false);
                    }
                    await GXPService.addPageImage(response.id, imageData);
                  });
                }
              })
              .catch((error) => {
                this.addNewPageDrawerHandle();
                this.submittedAddNewPage = false;
                this.isAddNewPageDataBtnLoading = false;
                errorHandler(error);
              });
          }
        }
      }
    },
    // Method is used to add new pages or connect pages
    addNewPageData() {
      if (this.PageData.template_page_type == null) {
        Middleware.notification("Please select page type !!", "success");

        return;
      }
      this.submittedAddNewPage = true;
      this.isAddNewPageDataBtnLoading = true;
      this.$v.$touch();
      if (this.$v.PageData.$invalid) {
        this.isAddNewPageDataBtnLoading = false;
        return;
      } else {
        this.isAddPageBtnLoading = false;
        const newPageData = new FormData();
        Object.keys(this.PageData).map((key) => {
          if (this.PageData[key] !== null) {
            if (key !== "selected_template" && key !== "template_page_type") {
              newPageData.append(key, this.PageData[key]);
            }
          }
        });
        newPageData.append("hotel", this.hotel.id);
        if (this.PageData.template_page_type.value == "list_page") {
          newPageData.append(
            "page_template_type",
            this.PageData.selected_template.value
          );
        } else {
          newPageData.append(
            "page_template_type",
            this.PageData.template_page_type.value
          );
        }
        newPageData.append("page_level", this.selectedCategory.page_level + 1);
        if (
          this.isTemplateSelect &&
          this.PageData.selected_template !== null &&
          this.PageData.template_page_type.value == "content_page"
        ) {
          newPageData.delete("images");
          GXPService.updatePage(
            this.PageData.selected_template.value.id,
            newPageData
          )
            .then((response) => {
              if (this.dynamicPages.find((item) => item.id == response.id)) {
                this.submittedAddNewPage = false;
                this.dynamicPages = this.dynamicPages.map((item) => {
                  if (item.id == response.id) {
                    item = response;
                  }
                  return item;
                });
                this.categoryPage = this.categoryPage.map((item) => {
                  if (item.id == response.id) {
                    item = response;
                  }
                  const modifyData = this.modifyData(item, "dynamic");
                  return modifyData;
                });
              } else {
                GXPService.addSubPages(
                  this.selectedCategory.id,
                  this.PageData.selected_template.value.id,
                  "add"
                )
                  .then((response) => {
                    this.submittedAddNewPage = false;
                    this.dynamicPages.push(response);
                    const modifyData = this.modifyData(response, "dynamic");
                    this.categoryPage.push(modifyData);
                  })
                  .catch((error) => {
                    this.isAddPageBtnLoading = false;
                    errorHandler(error);
                  });
              }
              this.isTemplateSelect = false;
              setTimeout(() => {
                document.querySelector(".has-icon").click();
                this.PageData = {
                  name: null,
                  image: null,
                  images: [],
                  description: null,
                  is_active: true,
                  redirect_url: null,
                  template_page_type: null,
                  selected_template: null,
                };
              }, 500);
            })
            .catch((error) => {
              this.isAddPageBtnLoading = false;
              errorHandler(error);
            });
        } else {
          GXPService.addPage(newPageData)
            .then((response) => {
              GXPService.addSubPages(
                this.selectedCategory.id,
                response.id,
                "add"
              );
              this.submittedAddNewPage = false;
              this.dynamicPages.push(response);
              const modifyData = this.modifyData(response, "dynamic");
              this.categoryPage.push(modifyData);
              setTimeout(() => {
                document.querySelector(".has-icon").click();
                this.PageData = {
                  name: null,
                  image: null,
                  images: [],
                  description: null,
                  is_active: true,
                  redirect_url: null,
                  template_page_type: null,
                  selected_template: null,
                };
              }, 500);
            })
            .catch((error) => {
              this.submittedAddNewPage = false;
              this.isAddPageBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
    // Method is used to remove pages
    removePage(data) {
      this.isRemovePageBtnLoading = false;
      GXPService.addSubPages(this.selectedCategory.id, data.id, "remove")
        .then((response) => {
          this.dynamicPages = this.dynamicPages.filter((item) => {
            return item.id !== data.id;
          });
          this.categoryPage = this.categoryPage.filter((item) => {
            return item.id !== data.id;
          });
          this.isRemovePageBtnLoading = false;
          Middleware.notification("Successfully remove !!", "success");
        })
        .catch((error) => {
          this.isRemovePageBtnLoading = false;
          errorHandler(error);
        });
    },
    // Method is used to handle light box
    openLightBox() {
      this.isShowLightBox = !this.isShowLightBox;
    },
    // Method is used for handle add new light box
    addNewLightBox() {
      this.$root.$emit("addNewLightBox", true);
    },
    // EXTRA METHODS HELPER

    // Method is used for open google map
    openGoogleMap(hotel) {
      if (this.hotel.map_location_url) {
        const urlSuffix = hotel["map_location_url"]
          ? hotel["map_location_url"]
          : hotel["map_location_url"];
        window.open(urlSuffix, "_blank");
      } else {
        document.getElementById("btn-1").disabled = true;
      }
    },
    // Method is use to modify data
    modifyData(data, processFor) {
      let thumbnailImage = null;
      let images = [];
      data = {
        ...data,
        description: data.description,
        thumbnailImage,
        images,
      };
      if (processFor == 103 || processFor == 104) {
        data.hotel_info_place_image.map((img) => {
          if (img.is_thumbnail == true) {
            thumbnailImage = img.image;
          }
        });
        images = data.hotel_info_place_image;
      }
      if (processFor == 105) {
        data.floor_image.map((img) => {
          if (img.is_thumbnail == true) {
            thumbnailImage = img.image;
          }
        });
        images = data.floor_image;
      }
      if (processFor == 108) {
        data.near_by_place_image.map((img) => {
          if (img.is_thumbnail == true) {
            thumbnailImage = img.image;
          }
        });
        images = data.near_by_place_image;
        data.description = `<div class="d-flex align-items-start"><i class="fas fa-map-marker-alt template-font-color fs-4 w-35"></i><span class="mx-2 template-menu-font">:</span><a :href="${data.g_website}" target="_blank" class="template-menu-font">Open Website</a></div><div class="border-bottom-dashed my-3"></div><div class="d-flex align-items-start pointer"><i class="bx bxs-time-five template-font-color fs-4 w-35"></i><span class="mx-2 template-menu-font">:</span><p class="mb-0 template-menu-font">${data.g_opening_time}</p></div><div class="border-bottom-dashed my-3"></div><div><div class="d-flex align-items-start"><i class="fas fa-map-marked-alt template-font-color fs-4 w-35"></i><span class="mx-2 template-menu-font">:</span><a :href="data.g_map_url" target="_blank" class="template-menu-font">Click here to Locate <i class="fas fa-location-arrow template-font-color"></i></a></div><div class="border-bottom-dashed my-3"></div></div>`;
      }
      if (
        processFor == "image" ||
        processFor == "local-event" ||
        processFor == "tv-channel"
      ) {
        thumbnailImage = data.image;
        images = [];
      }
      if (processFor == "dynamic") {
        data.hd_page_image.map((img) => {
          if (img.is_thumbnail == true) {
            thumbnailImage = img.image;
          }
        });
        images = data.hd_page_image;
      }
      data.thumbnailImage = thumbnailImage;
      data.images = images;
      return data;
    },
    // Method is used to update data
    updatePageDataHelper(dataToProcess, processTo, method) {
      if (method == "map") {
        const data = this.modifyData(dataToProcess, processTo);
        this.categoryPage = this.categoryPage.map((item) => {
          if (item.id == data.id) {
            item = data;
          }
          return item;
        });
        Middleware.notification("change apply successfully !!", "success");
      }
      if (method == "filter") {
        this.Pages = this.Pages.filter(
          (item) => item.id !== dataToProcess.menu.id
        );
      }
      if (method == "push") {
        this.Pages.push(dataToProcess);
      }
      this.$root.$emit("updateMenuData", this.Pages);
    },
    // Method is used to open dropdown button
    openDropdown(index) {
      this.$refs.categoryDropdown[index].show();
    },
    // Method is used to reset values
    resetVariables() {
      this.categoryPage = [];
      this.isPageActive = false;
      this.selectedCategory = "Category";
      this.isMainPage = false;
      this.categoryData = {};
      this.isEdit = false;
      this.isPageHasSubCategory = false;
      this.mainCategory = null;
      this.isCategoryDetail = false;
      this.dataToBeSendInProps = {};
      this.isHaveDetails = true;
      this.dataLoading = true;
      this.lastSelectedCategory = null;
      this.hotelDrawerOpen = false;
      this.imgUrl = null;
      this.submittedCategoryData = false;
      this.isCategoryDataBtnLoading = false;
      this.page_template_type = null;
      this.categoryUpdateData = {
        id: null,
        name: null,
        image: null,
        images: [],
        description: null,
        is_active: true,
      };
      this.dynamicPages = [];
      this.addNewPageImages = [];
      this.isAddNewPage = false;
      this.PageTitle = "Add New Page";
      this.PageData = {
        name: null,
        image: null,
        images: [],
        description: null,
        is_active: true,
        redirect_url: null,
        template_page_type: null,
        selected_template: null,
      };
      this.pageTypeOptions = [];
      this.isTemplateSelect = false;
      this.isAddPageBtnLoading = false;
      this.isRemovePageBtnLoading = false;
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xl-5 col-lg-7" v-if="!isCategoryDetail">
        <div class="iphone">
          <div class="iphone-top">
            <span class="camera"></span>
            <span class="sensor"></span>
            <span class="speaker"></span>
          </div>
          <div class="top-bar"></div>
          <div class="position-relative">
            <div
              :class="
                currentProps.backgroundImage !== null
                  ? 'bg-img'
                  : 'template-theme'
              "
              :style="{
                'background-image': `url(${
                  currentProps.backgroundImage !== null
                    ? currentProps.backgroundImage.image
                    : ''
                })`,
              }"
            >
              <div class="iphone-screen">
                <div class="p-2 position-relative template-title-bg mb-2">
                  <p
                    class="template-title-font fw-bold mb-0 text-center text-capitalize text-truncate"
                  >
                    {{ selectedCategory.name }}
                  </p>
                </div>
                <div class="mobile-box">
                  <div class="container">
                    <div class="row justify-content-center" v-if="dataLoading">
                      <div
                        class="placeholder-glow col-md-5 px-2 mb-3"
                        v-for="no in 10"
                        :key="no"
                      >
                        <span
                          class="placeholder placeholder-lg mobile-box-card w-100 m-0"
                        ></span>
                      </div>
                    </div>
                    <div v-if="!dataLoading">
                      <div
                        v-if="
                          selectedCategory.page_template_type == undefined ||
                          selectedCategory.page_template_type ==
                            'list_page_second'
                        "
                        class="d-flex align-items-center justify-content-center flex-wrap"
                      >
                        <div
                          v-for="(page, index) in categoryPage"
                          :key="index"
                          @click="openDropdown(index)"
                        >
                          <div
                            :id="page.id"
                            v-if="page.is_active"
                            class="hotel-box-card m-2 cursor position-relative"
                          >
                            <b-dropdown
                              ref="categoryDropdown"
                              class="mb-0 template-dropdown"
                              toggle-class="btn btn-link text-light"
                              menu-class="dropdown-menu-end"
                              right
                              variant="white"
                            >
                              <template #button-content>
                                <i
                                  class="mdi mdi-dots-vertical font-size-20"
                                ></i>
                              </template>
                              <b-dropdown-item
                                href="#"
                                @click="openMainCategoryPageDetail(page)"
                                >Open</b-dropdown-item
                              >
                              <b-dropdown-item
                                href="#"
                                v-if="isMainPage && !isPageHasSubCategory"
                                @click="hotelButton(page)"
                                >Edit</b-dropdown-item
                              >
                            </b-dropdown>
                            <v-lazy-image
                              v-if="
                                page.image !== null && page.image !== undefined
                              "
                              :src="page.image"
                              alt=""
                            />
                            <v-lazy-image
                              v-else-if="page.thumbnailImage !== null"
                              :src="page.thumbnailImage"
                              alt=""
                            />
                            <img
                              v-else
                              src="@/assets/images/placeholder.png"
                              alt=""
                            />
                            <div
                              class="d-flex align-items-center justify-content-between hotel-name"
                            >
                              <p class="mb-0 text-light fw-light text-truncate">
                                {{ page.name }}
                              </p>
                              <i class="fas fa-long-arrow-alt-right"></i>
                            </div>
                          </div>
                        </div>
                        <div
                          id="add_new"
                          @click="openCategoryPageDetails('addNewPage')"
                        >
                          <div
                            class="first-add-new card m-2 cursor d-flex align-items-center justify-content-center"
                          >
                            <div class="text-center">
                              <i class="fas fa-plus fs-5"></i>
                              <h5 class="font-size-16 mb-0">New Add</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="
                          selectedCategory.page_template_type ==
                          'list_page_first'
                        "
                        class="px-2"
                      >
                        <div
                          v-for="(page, index) in categoryPage"
                          :key="index"
                          @click="openDropdown(index)"
                        >
                          <div
                            :id="page.id"
                            v-if="page.is_active"
                            class="hotel-box-card mb-3 cursor position-relative"
                          >
                            <b-dropdown
                              ref="categoryDropdown"
                              class="mb-0 template-dropdown"
                              toggle-class="btn btn-link text-light"
                              menu-class="dropdown-menu-end"
                              right
                              variant="white"
                            >
                              <template #button-content>
                                <i
                                  class="mdi mdi-dots-vertical font-size-20"
                                ></i>
                              </template>
                              <b-dropdown-item
                                href="#"
                                v-if="isMainPage && !isPageHasSubCategory"
                                @click="hotelButton(page)"
                                >Edit</b-dropdown-item
                              >
                              <b-dropdown-item
                                href="#"
                                @click="openMainCategoryPageDetail(page)"
                                >Open</b-dropdown-item
                              >
                            </b-dropdown>
                            <v-lazy-image
                              v-if="
                                page.image !== null && page.image !== undefined
                              "
                              :src="page.image"
                              alt=""
                              class="w-100"
                            />
                            <v-lazy-image
                              v-else-if="page.thumbnailImage !== null"
                              :src="page.thumbnailImage"
                              alt=""
                              class="w-100"
                            />
                            <img
                              v-else
                              src="@/assets/images/placeholder.png"
                              alt=""
                              class="w-100"
                            />
                            <div
                              class="d-flex align-items-center justify-content-between hotel-name"
                            >
                              <p class="mb-0 text-light fw-light text-truncate">
                                {{ page.name }}
                              </p>
                              <i class="fas fa-long-arrow-alt-right"></i>
                            </div>
                          </div>
                        </div>
                        <div id="add_new" @click="openCategoryPageDetails()">
                          <div
                            class="first-add-new card mb-3 cursor d-flex align-items-center justify-content-center w-100"
                          >
                            <div class="text-center">
                              <i class="fas fa-plus fs-5"></i>
                              <h5 class="font-size-16 mb-0">New Add</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="float-btn cursor" @click="openLightBox">
              <i class="fas fa-box"></i>
            </div>
            <div class="back-btn cursor" @click="openHomePage()">
              <i class="fas fa-angle-left fs-4"></i>
            </div>
          </div>
          <div class="buttons">
            <span class="on-off"></span>
            <span class="sleep"></span>
            <span class="up"></span>
            <span class="down"></span>
          </div>
          <div class="bottom-bar"></div>
          <div class="iphone-bottom">
            <span></span>
          </div>
        </div>
      </div>
      <div class="col-xl-5 col-lg-7" v-if="isCategoryDetail">
        <div class="iphone">
          <div class="iphone-top">
            <span class="camera"></span>
            <span class="sensor"></span>
            <span class="speaker"></span>
          </div>
          <div class="top-bar"></div>
          <div class="position-relative">
            <div
              :class="
                currentProps.backgroundImage !== null
                  ? 'bg-img'
                  : 'template-theme'
              "
              :style="{
                'background-image': `url(${
                  currentProps.backgroundImage !== null
                    ? currentProps.backgroundImage.image
                    : ''
                })`,
              }"
            >
              <div class="iphone-screen">
                <div class="template-title-bg p-2 position-relative">
                  <p
                    class="template-title-font fw-bold mb-0 text-center text-capitalize text-truncate"
                  >
                    {{ categoryData.name.replaceAll("-", " ") }}
                  </p>
                </div>

                <!-- Category -->
                <div class="mobile-box" v-if="!isHaveDetails">
                  <div class="px-3">
                    <div class="hotel-detail-box mt-3">
                      <carousel
                        v-if="categoryData.images.length !== 0"
                        :autoplay="true"
                        :loop="categoryData.images.length > 1 ? true : false"
                        :nav="false"
                        :dots="false"
                        :responsive="{ 0: { items: 1 } }"
                      >
                        <img
                          v-for="(img, index) in categoryData.images"
                          :key="index"
                          :src="img.image"
                          class="detail-img"
                        />
                      </carousel>
                      <v-lazy-image
                        v-else-if="categoryData.thumbnailImage !== null"
                        :src="categoryData.thumbnailImage"
                        alt=""
                        class="detail-img"
                      />
                      <v-lazy-image
                        v-else-if="
                          categoryData.image !== null &&
                          categoryData.image !== undefined
                        "
                        :src="categoryData.image"
                        alt=""
                        class="detail-img"
                      />
                      <img
                        v-else
                        src="@/assets/images/placeholder.png"
                        alt=""
                        class="detail-img"
                      />
                      <div
                        class="card template-menu-bg template-theme-border template-menu-font mt-3"
                      >
                        <div class="py-3 px-2">
                          <div v-html="categoryData.description"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Location -->
                <div
                  class="mobile-box"
                  v-else-if="
                    isHaveDetails && selectedCategory.feature_code == 107
                  "
                >
                  <div
                    class="card template-menu-bg template-theme-border template-menu-font mx-2 mt-2"
                  >
                    <div class="p-3">
                      <h4 class="template-menu-font text-center">
                        Our Location
                      </h4>
                      <div class="d-flex align-items-start mb-3">
                        <i class="fs-4 fas fa-map-marker-alt" />
                        <span class="mx-2">:</span>

                        <span class="mb-0">
                          {{ hotel.name }}, {{ hotel.address }},
                          {{ hotel.city }}, {{ hotel.state }},
                          {{ hotel.zip_code }}
                        </span>
                      </div>
                      <h4 class="template-menu-font text-center">
                        Our Contacts
                      </h4>
                      <div class="d-flex align-items-center mb-3">
                        <i class="fas fa-phone-alt fs-5 rotate-icon" />
                        <span class="mx-2">:</span>
                        <h6 class="mb-0" v-if="hotel.front_desk_number">
                          <a
                            class="template-menu-font"
                            :href="'tel:' + hotel.front_desk_number"
                          >
                            {{ hotel.front_desk_number }}
                          </a>
                        </h6>
                      </div>
                      <div class="d-flex align-items-center mb-3">
                        <i class="fs-5 fas fa-envelope" />
                        <span class="mx-2">:</span>
                        <h6 class="mb-0" v-if="hotel.email">
                          <a
                            class="template-menu-font"
                            :href="'mailto:' + hotel.email"
                          >
                            {{ hotel.email }}
                          </a>
                        </h6>
                      </div>
                      <div class="text-center">
                        <i
                          id="btn-1"
                          class="fas fa-location-arrow cursor fs-5 p-3 location-btn rounded-pill mt-4 mb-3"
                          @click="openGoogleMap(hotel)"
                        >
                        </i>
                        <h5
                          class="template-menu-font mb-0"
                          @click="openGoogleMap(hotel)"
                        >
                          Open With Map
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Rate Your Stay -->
                <div
                  class="p-3 mobile-box"
                  v-else-if="
                    isHaveDetails && selectedCategory.feature_code == 115
                  "
                >
                  <div class="card template-menu-bg template-theme-border p-3">
                    <div class="text-center">
                      <h4 class="template-menu-font fw-normal mb-3">
                        How was your stay?
                      </h4>
                      <p class="template-menu-font">
                        Thanks for stay with Best Western Burlington Inn, Could
                        you take a few seconds to let us know how you would rate
                        your experience?
                      </p>
                      <h4 class="template-menu-font fw-normal my-3">
                        How would you rate us overall?
                      </h4>
                      <div
                        class="d-flex align-items-center justify-content-center mb-3"
                      >
                        <i class="fas fa-star fs-1 px-2 text-warning"></i>
                        <i class="fas fa-star fs-1 px-2 text-warning"></i>
                        <i class="fas fa-star fs-1 px-2 text-warning"></i>
                        <i class="fas fa-star fs-1 px-2 text-secondary"></i>
                        <i class="fas fa-star fs-1 px-2 text-secondary"></i>
                      </div>
                      <h4 class="template-menu-font fw-normal">
                        How can we improve?
                      </h4>
                      <b-form-textarea
                        placeholder="Feedback"
                        autocomplete="off"
                        rows="3"
                        class="bg-transparent template-theme-border"
                      ></b-form-textarea>

                      <button
                        class="hotel-btn w-100 btn template-theme-border p-2 fs-5 mt-3"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Live Score -->
                <div
                  class="px-3 pt-3 mobile-box"
                  v-else-if="
                    isHaveDetails && selectedCategory.feature_code == 111
                  "
                >
                  <img
                    src="@/assets/images/live-score.png"
                    alt=""
                    class="w-100"
                  />
                </div>

                <!-- Other -->
                <div class="px-3 pt-5 mobile-box template-theme" v-else>
                  <h4 class="text-uppercase text-center template-font-color">
                    Sorry, Page not found.
                  </h4>
                  <img
                    src="@/assets/images/error-img.png"
                    alt
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div
              class="back-btn cursor"
              @click="goBackToCategory(selectedCategory)"
            >
              <i class="fas fa-angle-left fs-4"></i>
            </div>
          </div>
          <div class="buttons">
            <span class="on-off"></span>
            <span class="sleep"></span>
            <span class="up"></span>
            <span class="down"></span>
          </div>
          <div class="bottom-bar"></div>
          <div class="iphone-bottom">
            <span></span>
          </div>
        </div>
      </div>
      <div class="col-xl-7 col-lg-5" v-if="!isCategoryDetail && isPageActive">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h5 class="mb-0 text-truncate text-capitalize">
            {{ selectedCategory.name }} page
            <span v-if="isShowLightBox">/ Light Box</span>
          </h5>
          <b-button
            v-show="isShowLightBox"
            class="float-end"
            variant="outline-primary"
            type="submit"
            @click="addNewLightBox"
          >
            Add New
          </b-button>
        </div>
        <hr />
        <LightBox v-if="isShowLightBox" :currentProps="lightBoxData" />
        <div class="category-scroll" v-else>
          <div
            class="row"
            v-if="selectedCategory.page_template_type == undefined"
          >
            <template v-if="dataLoading">
              <div
                class="col-xl-4 col-lg-12 col-md-6"
                v-for="no in 15"
                :key="no"
              >
                <div class="m-2 placeholder-glow">
                  <span class="placeholder placeholder-lg w-100 p-3"></span>
                </div>
              </div>
            </template>
            <template v-if="!dataLoading">
              <div
                class="col-xl-4 col-lg-12 col-md-6"
                v-for="(page, index) in categoryPage"
                :key="index"
              >
                <div
                  class="form-check form-switch form-switch-md mb-4 d-flex category-options"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="page.name"
                    :checked="page.is_active"
                    v-model="page.is_active"
                    @click="changePageStatus(page)"
                  />
                  <label
                    :for="page.name"
                    class="form-check-label text-truncate"
                    >{{ page.name }}</label
                  >
                </div>
              </div>
            </template>
          </div>

          <div class="row" v-else>
            <div v-if="dynamicPages.length !== 0">
              <div
                class="row"
                v-for="(page, index) in dynamicPages"
                :key="index"
              >
                <div class="col-md-3">
                  <label for="page_image">Page Image</label>
                  <v-lazy-image
                    v-if="page.image !== null"
                    :src="page.image"
                    class="common-upload-img-size mb-3 w-100 object-fit"
                    alt=""
                  />
                  <VueDropify
                    v-else
                    @upload="changeGalleryImage($event, page)"
                    :src="page.image"
                    message="Drop image or click here to select"
                    uploadIcon="fa fa-upload"
                    height="150px"
                    width="100%"
                    id="infoServices_images"
                    class="mb-3 w-100"
                  />
                </div>
                <div class="col-md-9">
                  <div class="row">
                    <div class="col-md-6">
                      <label for="page_name">Page Name</label>
                      <div class="mb-3">
                        <b-form-input
                          id="page_name"
                          :value="page.name"
                          disabled
                        ></b-form-input>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label for="selected_template">Selected Template</label>
                      <div class="mb-3">
                        <b-form-input
                          v-if="page.template_page_type == 'redirect_url'"
                          id="redirect_url"
                          :value="page.redirect_url"
                          disabled
                        ></b-form-input>
                        <span
                          v-if="
                            page.template_page_type !== 'redirect_url' &&
                            page.template_page_type !== 'add_new_page'
                          "
                        >
                          <b-form-input
                            id="selected_template"
                            disabled
                            :value="page.name"
                          ></b-form-input>
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label>Page Type</label>
                        <b-form-input
                          id="page_template_type"
                          class="text-capitalize"
                          :value="page.page_template_type.replaceAll('_', ' ')"
                          disabled
                        ></b-form-input>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <b-button
                        class="mt-4"
                        variant="danger"
                        @click="removePage(page)"
                        :class="{ disabled: isRemovePageBtnLoading }"
                      >
                        <i
                          v-if="isRemovePageBtnLoading"
                          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                        ></i>
                        Remove
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <label for="page_image">Page Image</label>
                <VueDropify
                  @upload="changeGalleryImage($event, 'add_new_page')"
                  :src="imgUrl"
                  message="Drop image or click here to select"
                  uploadIcon="fa fa-upload"
                  height="150px"
                  width="100%"
                  id="infoServices_images"
                  class="mb-3 w-100"
                />
              </div>
              <div class="col-md-9">
                <div class="row">
                  <div class="col-md-6">
                    <label for="page_name">Page Name</label>
                    <div class="mb-3">
                      <b-form-input
                        id="page_name"
                        type="text"
                        placeholder="Enter Page Name"
                        autocomplete="off"
                        v-model="PageData.name"
                        :class="{
                          'is-invalid':
                            submittedAddNewPage && $v.PageData.name.$error,
                        }"
                      ></b-form-input>
                      <div v-if="submittedAddNewPage" class="invalid-feedback">
                        <span v-if="!$v.PageData.name.required"
                          >Page name is required.</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="page_name">Page Type</label>
                      <MultiSelect
                        placeholder="Select Template"
                        label="text"
                        track-by="value"
                        :options="[
                          {
                            value: 'add_new_page',
                            text: 'Add New Content Page',
                          },
                          { value: 'content_page', text: 'Content Page' },
                          { value: 'redirect_url', text: 'Redirect URL' },
                          { value: 'list_page', text: 'List Page' },
                        ]"
                        :show-labels="false"
                        :allow-empty="false"
                        v-model="PageData.template_page_type"
                        @close="handleTemplateTypeSelection"
                      ></MultiSelect>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <span
                        v-if="
                          PageData.template_page_type !== null &&
                          PageData.template_page_type.value == 'redirect_url'
                        "
                      >
                        <label for="page_type">Select Type</label>

                        <b-form-input
                          id="redirect_url"
                          type="text"
                          placeholder="Enter Redirect URL"
                          autocomplete="off"
                          v-model="PageData.redirect_url"
                        ></b-form-input>
                      </span>
                      <span
                        v-if="
                          PageData.template_page_type !== null &&
                          PageData.template_page_type.value !==
                            'redirect_url' &&
                          PageData.template_page_type.value !== 'add_new_page'
                        "
                      >
                        <label for="page_type">Select Type</label>
                        <MultiSelect
                          placeholder="Select Template"
                          label="text"
                          track-by="value"
                          :options="pageTypeOptions"
                          :show-labels="false"
                          v-model="PageData.selected_template"
                          @close="selectTemplate"
                        ></MultiSelect>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div
                      class="mb-3"
                      v-if="
                        PageData.template_page_type !== null &&
                        PageData.template_page_type.value !== 'add_new_page'
                      "
                    >
                      <b-button
                        class="mt-4"
                        variant="primary"
                        @click="addNewPageData()"
                        :class="{ disabled: isAddPageBtnLoading }"
                      >
                        <i
                          v-if="isAddPageBtnLoading"
                          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                        ></i
                        >+ Add
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-7 col-lg-5" v-else>
        <div class="row">
          <div class="col-md-11 directory-scroll" v-if="hotelDrawerOpen">
            <h4 class="text-truncate text-capitalize">
              Update {{ selectedCategory.name }}
            </h4>
            <hr />
            <form ref="header-form" @submit.stop.prevent="handleCategorySubmit">
              <div class="mb-3">
                <label for="name">
                  Name <span class="text-danger">*</span>
                </label>
                <b-form-input
                  id="room_type"
                  type="text"
                  placeholder="Hotel Directory"
                  autocomplete="off"
                  v-model="categoryUpdateData.name"
                ></b-form-input>
              </div>
              <div class="row">
                <label for="g_image">Gallery Image</label>
                <div
                  class="col-md-3 mb-3"
                  v-for="(image, index) in categoryData.images"
                  :key="index"
                >
                  <div class="d-flex align-items-start">
                    <img
                      class="rounded common-upload-img-size object-fit"
                      alt="detail_image"
                      :src="image.image"
                      :id="index"
                      data-holder-rendered="true"
                    />
                    <div class="ms-1">
                      <div class="form-check">
                        <input
                          :disabled="
                            categoryData.images.length == 1 &&
                            image.is_thumbnail
                          "
                          class="form-check-input"
                          type="checkbox"
                          :id="image.is_thumbnail"
                          v-model="image.is_thumbnail"
                          v-b-popover.hover="'Use as thumbnail image'"
                          @change="changeThumbnailImageStatus(image)"
                        />
                      </div>
                      <i
                        class="mdi mdi-trash-can fs-5 text-danger"
                        v-if="categoryData.images.length !== 1"
                        slot="label"
                        @click="deleteCategoryPageImage(image)"
                      ></i>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <VueDropify
                      @upload="changeCategoryImage($event, 'in_detail')"
                      :src="imgUrl"
                      message="Drop image or click here to select"
                      uploadIcon="fa fa-upload"
                      height="150px"
                      width="100%"
                      id="infoServices_images"
                      class="mb-3 w-100"
                    />
                  </div>
                </div>
                <tinymce
                  id="tinyMce-editor"
                  v-model="categoryUpdateData.description"
                  :plugins="plugins"
                  :toolbar="toolbar"
                  :other_options="options"
                ></tinymce>
              </div>
              <div class="mt-3">
                <b-button
                  class="ms-3 float-end"
                  variant="outline-danger"
                  @click="deleteCategoryPage(categoryData)"
                  >Delete
                </b-button>
                <b-button
                  class="float-end"
                  variant="outline-primary"
                  @click="handleCategorySubmit"
                  :class="{ disabled: isCategoryDataBtnLoading }"
                  ><i
                    v-if="isCategoryDataBtnLoading"
                    class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                  ></i
                  >Save
                </b-button>
              </div>
            </form>
          </div>
        </div>
        <!-- HOTEL INFO -->
        <div class="row" v-if="selectedCategory.feature_code == 104">
          <div class="col-xl-11 directory-scroll">
            <InfoAndServices
              :currentProps="infoAndServicesProps"
              @submitted="openCategoryPageDetails"
            />
          </div>
        </div>
        <!-- MY ROOM INFO -->
        <div class="row" v-if="selectedCategory.feature_code == 103">
          <div class="col-xl-11 directory-scroll">
            <RoomDetail
              :currentProps="RoomDetailProps"
              @submitted="openCategoryPageDetails"
              @cancelSubmit="openCategoryPageDetails"
            />
          </div>
        </div>
        <!-- LOCAL EVENT -->
        <div v-if="selectedCategory.feature_code == 109">
          <div class="directory-scroll">
            <LocalEvent
              :currentProps="localEventProps"
              @submitted="openCategoryPageDetails"
              @cancelSubmit="openCategoryPageDetails"
            />
          </div>
        </div>
        <!-- NEAR BY PLACE -->
        <div v-if="isPageHasSubCategory && mainCategory == 'nearby-place'">
          <div class="directory-scroll">
            <NearByPlace
              :currentProps="nearByPlaceProps"
              @submitted="openCategoryPageDetails"
              @cancelSubmit="openCategoryPageDetails"
            />
          </div>
        </div>
        <!-- TV CHANNEL -->
        <div v-if="isPageHasSubCategory && mainCategory == 'tv-channel'">
          <div class="directory-scroll">
            <TVChannel
              :currentProps="tvChannelProps"
              @submitted="openCategoryPageDetails"
              @cancelSubmit="openCategoryPageDetails"
            />
          </div>
        </div>
        <!-- FLOOR PLAN -->
        <div v-if="selectedCategory.feature_code == 105">
          <div class="directory-scroll">
            <Floor
              :currentProps="floorProps"
              @submitted="openCategoryPageDetails"
              @cancelSubmit="openCategoryPageDetails"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Drawer is for update nearby place and tv change category -->
    <Drawer
      @close="hotelButton"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="675"
    >
      <div
        class="col-md-12"
        v-if="
          hotelDrawerOpen && selectedCategory.page_template_type == undefined
        "
      >
        <h4 class="text-truncate text-capitalize">
          Update {{ selectedCategory.name }}
        </h4>
        <hr />
        <form ref="header-form" @submit.stop.prevent="handleCategorySubmit">
          <div class="mb-3">
            <label for="name"> Name <span class="text-danger">*</span> </label>
            <b-form-input
              id="room_type"
              type="text"
              placeholder="Hotel Directory"
              autocomplete="off"
              v-model="categoryUpdateData.name"
            ></b-form-input>
          </div>
          <div class="mb-3">
            <label for="image">Image <span class="text-danger">*</span></label>
            <VueDropify
              @upload="changeCategoryImage($event)"
              :src="categoryUpdateData.image"
              message="Drop image or click here to select"
              uploadIcon="fa fa-upload"
              height="150px"
              width="100%"
              id="category_image"
              class="mb-3 w-100"
            />
          </div>

          <div>
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="hotelButton"
              >Cancel</b-button
            >
            <b-button
              class="float-end"
              variant="outline-primary"
              @click="handleCategorySubmit"
              :class="{ disabled: isCategoryDataBtnLoading }"
              ><i
                v-if="isCategoryDataBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i
              >Save
            </b-button>
          </div>
        </form>
      </div>
    </Drawer>

    <!-- Drawer is use to Add New Category -->
    <Drawer
      @close="addNewPageDrawerHandle"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="675"
    >
      <div v-if="isAddNewPage">
        <h4>{{ PageTitle }}</h4>
        <hr />
        <form ref="header-form" @submit.stop.prevent="handleNewPageSubmit">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="button_name">
                Page Name <span class="text-danger">*</span>
              </label>
              <b-form-input
                id="button_name"
                type="text"
                placeholder="Hotel Directory"
                autocomplete="off"
                v-model="PageData.name"
                :class="{
                  'is-invalid': submittedAddNewPage && $v.PageData.name.$error,
                }"
              ></b-form-input>
              <div v-if="submittedAddNewPage" class="invalid-feedback">
                <span v-if="!$v.PageData.name.required"
                  >Page name is required.</span
                >
              </div>
            </div>
          </div>

          <div class="row">
            <label for="g_image">Gallery Image</label>
            <div class="col-md-4">
              <div class="mb-3">
                <VueDropify
                  @upload="changeAddNewPageImage($event)"
                  :src="imgUrl"
                  message="Drop image or click here to select"
                  uploadIcon="fa fa-upload"
                  height="150px"
                  width="100%"
                  id="infoServices_images"
                  class="mb-3 w-100"
                />
              </div>
            </div>
            <div
              class="col-md-4 mb-3"
              v-for="(image, index) in addNewPageImages"
              :key="index"
            >
              <div class="d-flex align-items-start">
                <img
                  class="rounded common-upload-img-size object-fit"
                  alt="detail_image"
                  :src="image"
                  :id="index"
                  data-holder-rendered="true"
                />
                <div class="ms-1">
                  <i
                    class="mdi mdi-trash-can fs-5 text-danger"
                    v-if="addNewPageImages.length !== 1"
                    slot="label"
                    @click="deleteAddNewPageImage(index)"
                  ></i>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <tinymce
                id="tinyMce-editor"
                v-model="PageData.description"
                :plugins="plugins"
                :toolbar="toolbar"
                :other_options="options"
              ></tinymce>
            </div>
          </div>
          <div class="mt-2">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="addNewPageDrawerHandle"
              >Cancel</b-button
            >
            <b-button
              class="float-end"
              variant="outline-primary"
              :class="{ disabled: isAddNewPageDataBtnLoading }"
              @click="handleNewPageSubmit"
              ><i
                v-if="isAddNewPageDataBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i
              >Save
            </b-button>
          </div>
        </form>
      </div>
    </Drawer>
  </div>
</template>

<style scoped>
.bg-img {
  width: 100%;
  height: 540px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow-y: auto;
}
.hotel-box-card img,
.first-add-new {
  width: 140px;
  height: 100px;
  object-fit: cover;
  border-radius: 6px;
}
.hotel-name {
  position: absolute;
  bottom: 0;
  padding: 6px;
  width: 100%;
  opacity: 0.9;
  color: #fff;
  border-radius: 0px 0px 6px 6px;
  background-color: #303233;
}
.detail-img {
  height: 175px;
  width: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.channel {
  border-radius: 6px;
}
.channel img {
  height: 70px;
  border-radius: 6px 0px 0px 6px;
}
.channel-lead-text i {
  position: absolute;
  top: 10px;
  right: 8px;
  color: #d7443e;
}
.location-btn {
  color: var(--template-btn-font);
  border: 1px solid var(--template-btn-border);
  background-color: var(--template-btn-bg);
}
</style>

<style>
.border-bottom-dashed {
  border-bottom: 1px dashed var(--template-theme-border);
}
.template-dropdown {
  position: absolute;
  right: -5px;
  top: -5px;
}
.category-options .form-check-input {
  min-width: 40px;
}
</style>
